import React from "react";
import Typography from "@mui/material/Typography";
import '../SbtierCSS/SbtierContactUs.css';
import SubmitQuery from "./SbtierSemiQweryForm";
import useDocumentMeta from "../hooks/useDocumentMeta";

function SbtierContactUs(){
    useDocumentMeta(
        "Contact Us",
        "Get in touch with SatyaBalTech Semiconductor. Email info@sbtsemiconductor.com or call +91 9871999238 to talk to our engineers."
    );

    return (
        <div className="sbtier-contact-page">
            <div className="sbtier-contact-hero">
                <div className="hero-inner">
                    <span className="hero-eyebrow">Contact</span>
                    <Typography variant="h3" component="h3" className="contact-hero-title">
                        Let's talk about your next chip.
                    </Typography>
                    <Typography variant="body1" className="contact-hero-text">
                        Tell us about your application and our engineers will get back to you within
                        seven working days.
                    </Typography>
                </div>
            </div>
            <SubmitQuery />
        </div>
    );
}

export default SbtierContactUs;
